module.exports = __webpack_public_path__ + "img/TailWing_II_Overview_Spare_CS.c78bbfa4.jpg";